import React, { FC, ReactNode } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { SnackbarProvider } from 'notistack';

import { ConfigProvider } from './ConfigProvider';
import { LocaleProvider } from './LocaleProvider';
import AllAuthProvider from './AllAuthProvider';
import * as Tooltip from '@radix-ui/react-tooltip';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5000,
    },
  },
});
const Providers: FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <ConfigProvider>
      <Tooltip.Provider>
        <BrowserRouter>
          <QueryClientProvider client={queryClient}>
            <AllAuthProvider>
              <LocaleProvider>
                <DndProvider backend={HTML5Backend}>
                  <SnackbarProvider
                    maxSnack={3}
                    autoHideDuration={3000}
                    anchorOrigin={{
                      vertical: 'top',
                      horizontal: 'center',
                    }}
                  >
                    {children}
                  </SnackbarProvider>
                </DndProvider>
              </LocaleProvider>
            </AllAuthProvider>
          </QueryClientProvider>
        </BrowserRouter>
      </Tooltip.Provider>
    </ConfigProvider>
  );
};

export default Providers;
